<template>
    <app-layout class="main">
        <div class="row panel-container">
            <transition name="bounce" mode="out-in">
                <panel>
                    <h2 slot="header">Pārsūtīt apstiprinājuma e-pastu</h2>

                    <p v-if="response.status === 'success'">Uz norādīto epastu ir nosūtīta jauna apstiprinājuma saite. Lūdzu, atver epastu un nospied uz saites.</p>
                    <form v-else role="form" method="POST" @submit.prevent="resend()" novalidate @keydown="errors.remove('generic')" >
                        <div class="content">
                            <label :class="{ 'is-invalid-label': errors.has('email') }">
                                <input type="email" v-model="form.email" name="email" v-validate="'required|email'" placeholder="E-pasts"
                                       :class="{ 'is-invalid-input': errors.has('email') }"/>
                                <span class="form-error is-visible" v-if="errors.has('email')">{{ errors.first('email') }}</span>
                            </label>
                        </div>
                    </form>

                    <div slot="footer" class="text-center" style="width:100%;">
                        <router-link v-if="response.status === 'success'" :to="{ name: 'home' }" class="button primary">Uz sākumu</router-link>
                        <button v-else @click.prevent="resend()" type="button" class="button primary" :disabled="form.busy === true">Pārsūtīt</button>
                    </div>
                </panel>
            </transition>
        </div>
    </app-layout>
</template>

<script>
    import AppLayout from '../../../layouts/AppLayout'
    import Panel from '../../../components/Panel'
    import auth from '../../../api/auth'
    import { Form } from '../../../modules/forms/Form'

    export default {

        name: 'resend',

        data() {
            return {

                response: {
                    status: null,
                    message: null
                },

                form: new Form({
                    email: null,
                })
            }
        },

        methods: {
            resend() {
                this.$validator.validateAll().then(result => {
                    if (!result) return;
                    this.form.busy = true;
                    auth.resend(this.form.email).then(response => {
                        console.log(response.data);
                        Object.assign(this.response, response.data);
                        this.form.busy = false;
                    }, response => {
                        this.errors.add('email', response.data.message);
                        this.form.busy = false
                    });
                });
            }
        },

        components: { AppLayout, Panel }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/auth/verification/Resend.vue